import React from "react";
import styles from "./index.module.css";
import { CardItem } from "@/constants/home";

interface CardModuleProps {
  cardList: Omit<CardItem, "url">[];
  title: string;
}

const CardModule = ({ cardList, title }: CardModuleProps) => {
  return (
    <div className={styles.cardWrap}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.cardList}>
        {cardList.map((item) => (
          <div className={styles.cardItem} key={item.title}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={item.img} alt={item.title} />
            <div className={styles.cardItemTitle}>{item.title}</div>
            <div className={styles.cardItemDesc}>{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardModule;
